import { useCallback, useState } from "react";

const KEY_PREFIX = "whgdocs.workItemNote.";

const readDraft = (key) => {
  if (!key) return "";
  try {
    return globalThis.sessionStorage?.getItem(key) || "";
  } catch {
    return "";
  }
};

const writeDraft = (key, value) => {
  if (!key) return;
  try {
    if (value) globalThis.sessionStorage?.setItem(key, value);
    else globalThis.sessionStorage?.removeItem(key);
  } catch {
    // Storage full or blocked: the draft still lives in component state.
  }
};

/**
 * The unsent note on a work item card. Survives the card unmounting —
 * switching document tabs, collapsing the panel, moving between the
 * document bar, the matter Work tab, and Home — for the rest of the
 * browser session. Session-scoped, not persistent, because notes can
 * carry client details and the machine may be shared.
 */
const useWorkItemNoteDraft = (itemId) => {
  const key = itemId != null ? `${KEY_PREFIX}${itemId}` : null;
  const [draft, setDraftState] = useState(() => ({ key, value: readDraft(key) }));

  // A card re-used for a different item picks up that item's draft.
  let current = draft;
  if (draft.key !== key) {
    current = { key, value: readDraft(key) };
    setDraftState(current);
  }

  const setNote = useCallback(
    (value) => {
      writeDraft(key, value);
      setDraftState({ key, value });
    },
    [key]
  );

  return [current.value, setNote];
};

export default useWorkItemNoteDraft;
